import * as React from "react";
import { UitkIcon } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { useLocalization } from "@shared-ui/localization-context";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { ArrowLinkProps, ARROW_LINK_DIRECTION } from "../../typings";

export const ArrowLink = ({ disabled, direction, onClick }: ArrowLinkProps) => {
  const { formatText } = useLocalization();
  const Icon = <UitkIcon name={`chevron_${direction}`} />;
  const isLeftArrow = direction === ARROW_LINK_DIRECTION.LEFT;
  const ariaLabel = formatText(`carousel.item.${isLeftArrow ? "prev" : "next"}`);

  return (
    <UitkLink className={disabled ? "disabled" : ""}>
      {disabled ? (
        <span aria-label={ariaLabel}>{Icon}</span>
      ) : (
        <TrackedLink
          role="button"
          aria-label={ariaLabel}
          onClick={onClick(!isLeftArrow)}
          moduleName="tripCostEstimator"
          rfrr={`links-arrow-${direction}`}
        >
          {Icon}
        </TrackedLink>
      )}
    </UitkLink>
  );
};

export default ArrowLink;
